import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgApproved = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "approved",
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			id: "Path_13075",
			"data-name": "Path 13075",
			d: "M0,0H24V24H0Z",
			fill: "none"
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Path_13076",
			"data-name": "Path 13076",
			d: "M12,21h0a9,9,0,0,1-9-9H3a9,9,0,0,1,9-9h0a9,9,0,0,1,9,9h0A9,9,0,0,1,12,21Z",
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Path_13077",
			"data-name": "Path 13077",
			d: "M16,10l-5,5L8,12",
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5
		})
	]
});
export default SvgApproved;
